import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useInsertUser = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [insertLoading, setInsertLoading] = useState(false);

  const insertRequest = (getUserList, setIsInsertModalOpen, payload) => {
    setInsertLoading(true);
    axiosClient
      .post(`SettingAccount/User/Insert`, payload)
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`افزودن با موفقیت انجام شد`, { variant: 'success' });
          getUserList();
          setIsInsertModalOpen(false);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setInsertLoading(false));
  };
  return { insertRequest, insertLoading };
};

export default useInsertUser;
